import AuthUserSelector from '../modules/authorization/AuthUserSelector';

export default (state, all = true, modules = []) => {
  if (all) {
    return {
      ...AuthUserSelector(state),
      app: state.get('app'),
    };
  }

  let stateInProps = {};

  if (modules.includes('app')) {
    stateInProps = Object.assign({}, stateInProps, { app: state.get('app') });
  }

  if(modules.includes('quickshopweb')) {
    stateInProps = Object.assign({}, stateInProps, { quickshopweb: state.get('quickshopweb') });
  }

  return stateInProps;
};
